import { createAuthClient } from 'better-auth/react';
import { stripeClient } from '@better-auth/stripe/client';

const API_BASE_URL = import.meta.env.VITE_API_URL ?? '';

export const authClient = createAuthClient({
  baseURL: API_BASE_URL || window.location.origin,
  basePath: '/auth',
  plugins: [
    stripeClient({
      subscription: true,
    }),
  ],
});
